import { ISnotrRoute } from '..';

export default [
  {
    path: '/subcompanies',
    name: 'SubUnits',
    meta: {
      title: 'TabTitle.subUnits',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/sub-units.vue'),
  },
] as ISnotrRoute[];
